<div *ngIf="settings$ | async" [formGroup]="form" class="content">
   <div class="flex flex--justify-between flex--align-center">
      <div class="flex">
         <h3 class="me-3">Email Settings</h3>
      </div>

      <button mat-raised-button [disabled]="form.invalid" color="accent" (click)="saveSettings()">Save</button>
   </div>

   <mat-card class="mb-4">
      <mat-card-content>
         <p class="mb-4">General settings</p>

         <div class="row">
            <div class="col-md-6 col-sm-12">
               <app-input-field
                  label="Email From"
                  placeholder="Enter email sender"
                  formControlName="emailFrom"
               ></app-input-field>
            </div>
            <div class="col-md-6 col-sm-12">
               <app-input-field
                  label="Incognito Email From"
                  placeholder="Enter email sender"
                  formControlName="incognitoEmailFrom"
               ></app-input-field>
            </div>
         </div>

         <div class="row">
            <div class="col-md-6 col-sm-12">
               <div class="flex flex--align-center">
                  <p>Email Variables</p>
                  <button mat-icon-button color="accent" (click)="addVariable()">
                     <mat-icon>add</mat-icon>
                  </button>
               </div>

               <ng-container formArrayName="emailVariables">
                  @for (field of variables.controls; track i; let i = $index) {
                     <div class="row w-100" [formGroupName]="i">
                        <div class="col-4">
                           <app-input-field
                              label="Name"
                              placeholder="Enter name"
                              formControlName="name"
                           ></app-input-field>
                        </div>
                        <div class="col-3">
                           <app-input-field
                              label="Value"
                              placeholder="Enter value"
                              formControlName="value"
                           ></app-input-field>
                        </div>
                        <div class="col-3">
                           <app-input-field
                              label="Incognito Value"
                              placeholder="Enter incognito value"
                              formControlName="incognitoValue"
                           ></app-input-field>
                        </div>
                        <div class="col-auto">
                           <button mat-icon-button color="accent" (click)="removeVariable(i)">
                              <mat-icon>remove</mat-icon>
                           </button>
                        </div>
                     </div>
                  }
               </ng-container>
            </div>

            <div class="col-md-6 col-sm-12">
               <div class="flex flex--align-center">
                  <p>Email Plans</p>
                  <button mat-icon-button color="accent" (click)="addPlan()">
                     <mat-icon>add</mat-icon>
                  </button>
               </div>

               <ng-container formArrayName="plans">
                  @for (field of plans.controls; track i; let i = $index) {
                     <div class="row w-100" [formGroupName]="i">
                        <div class="col-4">
                           <app-input-field
                              label="Name"
                              placeholder="Enter name"
                              formControlName="name"
                           ></app-input-field>
                        </div>
                        <div class="col-3">
                           <app-input-field
                              label="Start Price"
                              placeholder="Enter End Price"
                              formControlName="priceStart"
                              type="number"
                           ></app-input-field>
                        </div>
                        <div class="col-3">
                           <app-input-field
                              label="End Price"
                              placeholder="Enter End Price"
                              formControlName="priceEnd"
                              type="number"
                           ></app-input-field>
                        </div>
                        <div class="col-auto">
                           <button mat-icon-button color="accent" (click)="removePlan(i)">
                              <mat-icon>remove</mat-icon>
                           </button>
                        </div>
                     </div>
                  }
               </ng-container>
            </div>
         </div>
      </mat-card-content>
   </mat-card>

   <mat-card class="mb-4">
      <mat-card-content>
         <p class="mb-4 bold">Sold Email Template</p>
         <div class="row mt-3">
            <div class="col">
               <div class="d-flex mb-3">
                  <p class="my-2">
                     <strong>Available Placeholder:</strong>
                  </p>

                  <button mat-button color="accent" (click)="setPlaceholder('emailHeader', '{{ customer.fullName }}')">
                     Name
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailHeader', '{{ customer.code }}')">
                     Code
                  </button>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('emailHeader', '{{ customer.plannedPickupDate }}')"
                  >
                     Planned Pickup Date
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailHeader', '{{ paymentLink }}')">
                     Payment Link
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailHeader', '{{ ticketLink }}')">
                     Ticket Link
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailHeader', '{{ planName }}')">
                     Plan
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailHeader', '{{ eventDate }}')">
                     Date of Event
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailHeader', '{{ paxNr }}')">
                     PAX NR
                  </button>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('emailHeader', '{{ ticketTypePricesHtml }}')"
                  >
                     Ticket Type Prices
                  </button>
               </div>

               <app-input-field
                  type="textarea"
                  label="Sold Message Header"
                  formControlName="emailHeader"
               ></app-input-field>
            </div>

            <div class="col">
               <div class="d-flex mb-3">
                  <p class="my-2">
                     <strong>Available Placeholder:</strong>
                  </p>

                  <button mat-button color="accent" (click)="setPlaceholder('emailFooter', '{{ totalPrice }}')">
                     Total Price
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailFooter', '{{ paid }}')">Paid</button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailFooter', '{{ restToPay }}')">
                     Rest to Pay
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailFooter', '{{ paymentLink }}')">
                     Payment Link
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailFooter', '{{ planName }}')">
                     Plan
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailFooter', '{{ eventDate }}')">
                     Date of Event
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailFooter', '{{ paxNr }}')">
                     PAX NR
                  </button>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('emailFooter', '{{ ticketTypePricesHtml }}')"
                  >
                     Ticket Type Prices
                  </button>
               </div>

               <app-input-field
                  type="textarea"
                  label="Sold Message Footer"
                  formControlName="emailFooter"
               ></app-input-field>
            </div>
         </div>

         <p class="mb-4 bold">Pickup Email Template</p>
         <div class="row mt-3">
            <div class="col">
               <div class="d-flex mb-3">
                  <p class="my-2">
                     <strong>Available Placeholder:</strong>
                  </p>

                  <button mat-button color="accent" (click)="setPlaceholder('emailHeader', '{{ customer.fullName }}')">
                     Name
                  </button>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('emailPickupHeader', '{{ customer.code }}')"
                  >
                     Code
                  </button>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('emailPickupHeader', '{{ customer.plannedPickupDate }}')"
                  >
                     Planned Pickup Date
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupHeader', '{{ paymentLink }}')">
                     Payment Link
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupHeader', '{{ ticketLink }}')">
                     Ticket Link
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupHeader', '{{ planName }}')">
                     Plan
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupHeader', '{{ eventDate }}')">
                     Date of Event
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupHeader', '{{ paxNr }}')">
                     PAX NR
                  </button>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('emailPickupHeader', '{{ ticketTypePricesHtml }}')"
                  >
                     Ticket Type Prices
                  </button>
               </div>

               <app-input-field
                  type="textarea"
                  label="Pickup Message Header"
                  formControlName="emailPickupHeader"
               ></app-input-field>
            </div>

            <div class="col">
               <div class="d-flex mb-3">
                  <p class="my-2">
                     <strong>Available Placeholder:</strong>
                  </p>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupFooter', '{{ totalPrice }}')">
                     Total Price
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupFooter', '{{ paid }}')">
                     Paid
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupFooter', '{{ restToPay }}')">
                     Rest to Pay
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupFooter', '{{ paymentLink }}')">
                     Payment Link
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupFooter', '{{ planName }}')">
                     Plan
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupFooter', '{{ eventDate }}')">
                     Date of Event
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailPickupFooter', '{{ paxNr }}')">
                     PAX NR
                  </button>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('emailPickupFooter', '{{ ticketTypePricesHtml }}')"
                  >
                     Ticket Type Prices
                  </button>
               </div>

               <app-input-field
                  type="textarea"
                  label="Pickup Message Footer"
                  formControlName="emailPickupFooter"
               ></app-input-field>
            </div>
         </div>

         <p class="mb-4 bold">Confrimation Order Email Template</p>
         <div class="row mt-3">
            <div class="col">
               <div class="d-flex mb-3">
                  <p class="my-2">
                     <strong>Available Placeholder:</strong>
                  </p>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('emailOrderConfirmation', '{{ fullName }}')"
                  >
                     Name
                  </button>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('emailOrderConfirmation', '{{ checkoutReference }}')"
                  >
                     Checkout Reference
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailOrderConfirmation', '{{ amount }}')">
                     Amount
                  </button>
               </div>

               <app-input-field
                  type="textarea"
                  label="Order Confimration"
                  formControlName="emailOrderConfirmation"
               ></app-input-field>
            </div>
         </div>

         <p class="mb-4 bold">Guest Email Template</p>
         <div class="row mt-3">
            <div class="col">
               <div class="d-flex mb-3">
                  <p class="my-2">
                     <strong>Available Placeholder:</strong>
                  </p>

                  <button mat-button color="accent" (click)="setPlaceholder('emailGuest', '{{ guestName }}')">
                     Name
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailGuest', '{{ amount }}')">
                     Amount
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailGuest', '{{ paymentLink }}')">
                     Payment Link
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('emailGuest', '{{ customerName }}')">
                     Customer Name
                  </button>
               </div>

               <app-input-field type="textarea" label="Guest Email" formControlName="emailGuest"></app-input-field>
            </div>
         </div>

         <p class="mb-4">Digital Ticket</p>

         <div class="row">
            <div class="col">
               <div class="d-flex mb-3">
                  <p class="my-2">
                     <strong>Available Placeholder:</strong>
                  </p>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('digitalHeader', '{{ customer.fullName }}')"
                  >
                     Name
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalHeader', '{{ customer.code }}')">
                     Code
                  </button>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('digitalHeader', '{{ customer.plannedPickupDate }}')"
                  >
                     Planned Pickup Date
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalHeader', '{{ paymentLink }}')">
                     Payment Link
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalHeader', '{{ planName }}')">
                     Plan
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalHeader', '{{ eventDate }}')">
                     Date of Event
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalHeader', '{{ paxNr }}')">
                     PAX NR
                  </button>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('digitalHeader', '{{ ticketTypePricesHtml }}')"
                  >
                     Ticket Type Prices
                  </button>
               </div>
               <app-input-field
                  type="textarea"
                  label="Digital Header"
                  formControlName="digitalHeader"
               ></app-input-field>
            </div>

            <div class="col">
               <div class="d-flex mb-3">
                  <p class="my-2">
                     <strong>Available Placeholder:</strong>
                  </p>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalFooter', '{{ totalPrice }}')">
                     Total Price
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalFooter', '{{ paid }}')">
                     Paid
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalFooter', '{{ paymentLink }}')">
                     Payment Link
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalFooter', '{{ restToPay }}')">
                     Rest to Pay
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalFooter', '{{ planName }}')">
                     Plan
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalFooter', '{{ eventDate }}')">
                     Date of Event
                  </button>

                  <button mat-button color="accent" (click)="setPlaceholder('digitalFooter', '{{ paxNr }}')">
                     PAX NR
                  </button>

                  <button
                     mat-button
                     color="accent"
                     (click)="setPlaceholder('digitalFooter', '{{ ticketTypePricesHtml }}')"
                  >
                     Ticket Type Prices
                  </button>
               </div>
               <app-input-field
                  type="textarea"
                  label="Digital Footer"
                  formControlName="digitalFooter"
               ></app-input-field>
            </div>
         </div>
      </mat-card-content>
   </mat-card>
</div>
